import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { TranslateService } from '@ngx-translate/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';
import { BaseController } from '../base.controller';
import { AlertService } from '@shared/src/services/alert/alert.service';
import { LoadingService } from '@shared/src/services/loading/loading.service';
import { NotificationTopicSchemaDto } from '@shared/src/dtos/notificationtopic/NotificationTopicSchemaDto';
import { EmailPreferencesDto } from '@shared/src/dtos/notificationtopic/EmailPreferencesDto';


@Injectable({
    providedIn: 'root',
})
export class OpenEmailPreferencesController extends BaseController {

    private base = '/public/emailpreferences'

    constructor(
        protected http: HttpClient,
        @Inject('AlertService') protected alertService: AlertService,
        protected translateService: TranslateService,
        @Inject('LoadingService') protected loadingService: LoadingService,
        protected router: Router
    ) {
        super(http, alertService, translateService, loadingService, router);
    }

    public getUserNotificationPreferences(uuid: string): Observable<EmailPreferencesDto> {
        return this.getBusy(this.base + "/uuid/" + uuid);
    }

    public getUserNotificationPreferencesFilter(uuid: string, filterKey: string): Observable<EmailPreferencesDto> {
        return this.getBusy(this.base + "/uuid/" + uuid + "/filter/" + filterKey);
    }

    public getUserNotificationPreferencesUnique(uuid: string, topic: string): Observable<EmailPreferencesDto> {
        return this.getBusy(this.base + "/uuid/" + uuid + "/topic/" + topic);
    }

    public updateUserNotificationPreference(uuid: string, dto: NotificationTopicSchemaDto): Observable<Boolean> {
        return this.post(this.base + "/uuid/" + uuid + "/update", dto, "updateUserNotificationPreference");
    }

    public updateUserNotificationPreferenceAll(uuid: string, state: number): Observable<Boolean> {
        return this.postBusy(this.base + "/uuid/" + uuid + "/updateall/" + state, "", "updateUserNotificationPreferenceAll");
    }

    public toggleUserExclusion(uuid: string,): Observable<Boolean> {
        return this.post(this.base + "/uuid/" + uuid + "/toggleexclusion", "", "toggleUserExclusion");
    }


    //
    // ------------| Email |------------------------------------------------------------------------------------------------------------
    //


    public getEmailNotificationPreferences(email: string): Observable<EmailPreferencesDto> {
        return this.getBusy(this.base + "/email/" + email);
    }

    public getEmailNotificationPreferencesFilter(email: string, filterKey: string): Observable<EmailPreferencesDto> {
        return this.getBusy(this.base + "/email/" + email + "/filter/" + filterKey);
    }

    public getEmailNotificationPreferencesUnique(email: string, topic: string): Observable<EmailPreferencesDto> {
        return this.getBusy(this.base + "/email/" + email + "/topic/" + topic);
    }

    public updateEmailNotificationPreference(email: string, dto: NotificationTopicSchemaDto): Observable<Boolean> {
        return this.post(this.base + "/email/" + email + "/update", dto, "updateEmailNotificationPreference");
    }

    public updateEmailNotificationPreferenceAll(email: string, state: number): Observable<Boolean> {
        return this.postBusy(this.base + "/email/" + email + "/updateall/" + state, "", "updateEmailNotificationPreferenceAll");
    }

    public toggleEmailExclusion(email: string,): Observable<Boolean> {
        return this.post(this.base + "/email/" + email + "/toggleexclusion", "", "toggleEmailExclusion");
    }

}
